import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AdminPageLayout from '../../../layout/AdminPageLayout';
import BgImageContent from '../../../layout/BgImageContent';
import backgroundImage from '../../../assets/images/admin-bg.png';
import LoginForm from '../../../forms/login';
import { useSelector } from 'react-redux';
import { logout, selectIsAuthenticated } from '../../../store/adminSlices/auth';
import Button from '../../../ui/Button';
import { useAppDispatch } from '../../../store';
import { APP_ROUTES } from '../../../app.config.vars/routes';
const LoginPage = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const isAuthenticated = useSelector(selectIsAuthenticated);
    const handleLogout = () => dispatch(logout());
    const handleManageRallies = () => navigate(APP_ROUTES.adminManageRallies);
    return (_jsx(AdminPageLayout, { children: _jsx("div", { className: `page-content-wrapper login-page${isAuthenticated ? ' logged-in' : ''}`, children: _jsx(BgImageContent, { backgroundColor: "#01978833", imageSrc: backgroundImage, imagePosition: 'bottom', title: t(isAuthenticated ? 'admin.logged_in' : 'admin.sign_in'), color: "#000", children: isAuthenticated ? (_jsxs(_Fragment, { children: [_jsx(Button, { onClick: handleManageRallies, label: t('admin.manage_rallies') }), _jsx(Button, { onClick: handleLogout, label: t('button.logout'), variant: 'outlined' })] })) : (_jsx(LoginForm, {})) }) }) }));
};
export default LoginPage;
